<template lang="pug">
  .column
    .row.menu-container
      button.row.center.middle(
        v-if='!heading'
        :title='$t("tiptap.menuItems.heading")'
        @click='editor.chain().focus().toggleHeading({level: 1}).run()'
        :class='{ "is-active": editor.isActive("heading", {level: 1}) }'
      )
        img.small(:src='headingIcon')
      button.row.center.middle.bolder(
        v-if='!bold'
        :title='$t("tiptap.menuItems.bold")'
        @click='editor.chain().focus().toggleBold().run()'
        :class='{ "is-active": editor.isActive("bold") }'
      )
        img.small(:src='boldIcon')
      button.row.center.middle.italic(
        v-if='!italic'
        :title='$t("tiptap.menuItems.italic")'
        @click='editor.chain().focus().toggleItalic().run()'
        :class='{ "is-active": editor.isActive("italic") }'
      )
        img.small(:src='italicIcon')
      button.row.center.middle.italic(
        v-if='!strike'
        :title='$t("tiptap.menuItems.strike")'
        @click='editor.chain().focus().toggleStrike().run()'
        :class='{ "is-active": editor.isActive("strike") }'
      )
        img.medium(:src='strikeIcon')
      button.row.center.middle.italic(
        v-if='!underline'
        :title='$t("tiptap.menuItems.underline")'
        @click='editor.chain().focus().toggleUnderline().run()'
        :class='{ "is-active": editor.isActive("underline") }'
      )
        img.small(:src='underlineIcon')
      button.row.center.middle.italic(
        v-if='!removeMarks'
        :title='$t("tiptap.menuItems.removeMarks")'
        @click='editor.chain().focus().unsetAllMarks().run()'
      )
        img.medium(:src='unsetMarksIcon')
      button.row.center.middle.italic(
        v-if='!removeMarks'
        :title='$t("tiptap.menuItems.alignLeft")'
        @click='editor.commands.setTextAlign("left")'
      )
        img.xlarge(:src='alignLeft')
      button.row.center.middle.italic(
        v-if='!removeMarks'
        :title='$t("tiptap.menuItems.alignCenter")'
        @click='editor.commands.setTextAlign("center")'
      )
        img.xlarge(:src='alignCenter')
      button.row.center.middle.italic(
        v-if='!removeMarks'
        :title='$t("tiptap.menuItems.alignRight")'
        @click='editor.commands.setTextAlign("right")'
      )
        img.xlarge(:src='alignRight')
      button.row.center.middle.italic(
        v-if='!removeMarks'
        :title='$t("tiptap.menuItems.alignJustify")'
        @click='editor.commands.setTextAlign("justify")'
      )
        img.xlarge(:src='alignJustify')
      button.row.center.middle.bolder(
        v-if='!unorderedList'
        :title='$t("tiptap.menuItems.unorderedList")'
        @click='editor.chain().focus().toggleBulletList().run()'
        :class='{ "is-active": editor.isActive("bulletList") }'
      )
        img(:src='bulletListIcon')
      button.row.center.middle.italic(
        v-if='!orderedList'
        :title='$t("tiptap.menuItems.orderedList")'
        @click='editor.chain().focus().toggleOrderedList().run()'
        :class='{ "is-active": editor.isActive("orderedList") }'
      )
        img(:src='orderedListIcon')
      v-popover(
        v-if='!table'
        placement='bottom-start'
        popoverClass='krea-actions-popover'
        trigger='hover click'
        :delay='{ show: 300, hide: 100 }'
      )
        button.row.center.middle.table(:title='$t("tiptap.menuItems.table")')
          img(:src='tableIcon')
        template(slot='popover')
          .table-menu.column.text-left
            h2.table-menu-item.text-small(
              @click='editor.chain().focus().insertTable({rows: 3, cols: 3, withHeaderRow: true}).run()'
            ) {{ $t("tiptap.tableMenu.insertTable") }}
            h2.table-menu-item.text-small(
              @click='editor.chain().focus().addColumnBefore().run()'
            ) {{ $t("tiptap.tableMenu.insertColumnBefore") }}
            h2.table-menu-item.text-small(
              @click='editor.chain().focus().addColumnAfter().run()'
            ) {{ $t("tiptap.tableMenu.insertColumnAfter") }}
            h2.table-menu-item.text-small(
              @click='editor.chain().focus().deleteColumn().run()'
            ) {{ $t("tiptap.tableMenu.deleteColumn") }}
            h2.table-menu-item.text-small(
              @click='editor.chain().focus().addRowBefore().run()'
            ) {{ $t("tiptap.tableMenu.insertRowBefore") }}
            h2.table-menu-item.text-small(
              @click='editor.chain().focus().addRowAfter().run()'
            ) {{ $t("tiptap.tableMenu.insertRowAfter") }}
            h2.table-menu-item.text-small(
              @click='editor.chain().focus().deleteRow().run()'
            ) {{ $t("tiptap.tableMenu.deleteRow") }}
            h2.table-menu-item.text-small(
              @click='editor.chain().focus().mergeCells().run()'
            ) {{ $t("tiptap.tableMenu.mergeCells") }}
            h2.table-menu-item.text-small(
              @click='editor.chain().focus().splitCell().run()'
            ) {{ $t("tiptap.tableMenu.splitCell") }}
            h2.table-menu-item.text-small(
              @click='editor.chain().focus().toggleHeaderColumn().run()'
            ) {{ $t("tiptap.tableMenu.toggleHeaderColumn") }}
            h2.table-menu-item.text-small(
              @click='editor.chain().focus().toggleHeaderRow().run()'
            ) {{ $t("tiptap.tableMenu.toggleHeaderRow") }}
            h2.table-menu-item.text-small(
              @click='editor.chain().focus().toggleHeaderCell().run()'
            ) {{ $t("tiptap.tableMenu.toggleHeaderCell") }}
            h2.table-menu-item.text-small(
              @click='editor.chain().focus().deleteTable().run()'
            ) {{ $t("tiptap.tableMenu.deleteTable") }}
      button.row.center.middle(
        v-if='!quote'
        :title='$t("tiptap.menuItems.quote")'
        @click='editor.chain().focus().toggleBlockquote({level: 1}).run()'
        :class='{ "is-active": editor.isActive("blockquote") }'
      )
        img(:src='quoteIcon')
      button.row.center.middle(
        v-if='!link'
        :title='$t("tiptap.menuItems.link")'
        @click='displayLinkInput'
        :class='{ "is-active": showLinkInput }'
      )
        img(:src='linkIcon')
      button.row.center.middle(
        v-if='!removeLink'
        :title='$t("tiptap.menuItems.removeLink")'
        @click='editor.chain().focus().unsetLink().run()'
        :disabled='!editor.isActive("link")'
      )
        img(:src='removeLinkIcon')
      button.row.center.middle.image-button(
        v-if='!image'
        :title='$t("tiptap.menuItems.image")'
        v-on-clickaway='hideImageOptions'
        @click='displayImageOptions'
        :class='{ "is-active": showImageOptions || showImageInput }'
      )
        img(:src='imageIcon')
        .image-options.column(v-if='showImageOptions')
          .row
            label.option.item-1.m4-right-1.terciary-button(for='image') {{ $t('tiptap.uploadImage') }}
            input.file-input(type='file' id='image' accept='image/png,image/jpg,image/jpeg' :value='imageFile' @change='uploadImage')
            .option.item-1.m4-left-1.terciary-button(@click='displayImageInput') {{ $t('tiptap.uploadImageByUrl') }}
          .row.m-bottom-1.middle.m-top-1.m4-left-2(v-if='imageSizeError || imageExtensionError')
            simple-svg.error-icon.red-icon.m4-right-2.red-stroke-icon(:filepath='errorIcon' :width='"16px"' :height='"16px"')
            span.text-small.red(v-if='imageSizeError') {{ $t('tiptap.imageFileSizeError') }}
            span.text-small.red(v-if='imageExtensionError') {{ $t('tiptap.imageExtensionError') }}
      button.row.center.middle(
        v-if='!video'
        :title='$t("tiptap.menuItems.video")'
        @click='displayVideoInput'
        :class='{ "is-active": showVideoInput }'
      )
        img(:src='videoIcon')
      button.row.center.middle(
        v-if='!undo'
        :title='$t("tiptap.menuItems.undo")'
        @click='editor.commands.undo()'
      )
        img(:src='undoIcon')
      button.row.center.middle(
        v-if='!redo'
        :title='$t("tiptap.menuItems.redo")'
        @click='editor.commands.redo()'
      )
        img(:src='redoIcon')
      button.row.center.middle(
        v-if='!preview'
        :title='$t("tiptap.menuItems.preview")'
        @click='$emit("togglePreview")'
        :class='{ "is-active": showPreview }'
      )
        img(:src='previewIcon')
      button.row.center.middle(
        v-if='!fullscreen'
        @click='$emit("toggleFullscreen")'
        :class='{ "is-active": showFullscreen }'
      )
        img(:src='fullscreenIcon')
      .m4-left-2.button-loading.option.item-1.m4-right-1.secondary-button(
        v-show='uploadingImage'
        id='upload-option'
      ) {{ $t('tiptap.uploading') }}
      .row.m-bottom-1.middle.m-top-1.m4-left-2(v-if='uploadImageError')
        simple-svg.error-icon.red-icon.m4-right-2.red-stroke-icon(:filepath='errorIcon' :width='"16px"' :height='"16px"')
        span.text-small.red(v-if='uploadImageError') {{ $t('tiptap.imageUploadError') }}
    .row.middle(v-if='showImageInput' v-on-clickaway='hideImageInput')
      input.item-6.input-base.input-border(
        name='imageUrl'
        ref='imageInput'
        @keydown.enter.prevent='submitImageUrl'
        :placeholder='$t("tiptap.placeholders.image")'
        v-model='imageUrl'
        @blur='hideImageInput'
      )
      button.m4-top-2.m-left-1.item-1.terciary-button(@click='submitImageUrl' id="submitImageUrl") {{ $t('tiptap.submitImageUrl') }}
    .row.middle(v-if='showLinkInput' v-on-clickaway='hideLinkInput')
      input.item-6.input-border.input-base(
        v-model='linkUrl'
        ref='linkInput'
        @keydown.enter.prevent='submitLinkUrl'
        :placeholder='$t("tiptap.placeholders.link")'
      )
      button.m4-top-2.m-left-1.item-1.terciary-button(@click='submitLinkUrl' id="submitLinkUrl") {{ $t('tiptap.submitLinkUrl') }}
    .column(v-if='showVideoInput' v-on-clickaway='hideVideoInput')
      .row
        input.item-6.input-border.input-base(
          v-model='videoUrl'
          ref='videoInput'
          @keydown.enter.prevent='submitVideoUrl'
          :placeholder='$t("tiptap.placeholders.video")'
        )
        button.m4-top-2.m-left-1.item-1.terciary-button(@click='submitVideoUrl' id="submitVideoUrl") {{ $t('tiptap.submitVideoUrl') }}
      .row.middle.m-top-05(v-if='invalidVideoUrl')
        simple-svg.red-icon.m-right-05.red-stroke-icon(:filepath='errorIcon' width='18px' height='18px')
        h2.text-small.red {{ $t('tiptap.invalidUrl') }}
</template>

<script>
import headingIcon from '@/assets/tiptap/heading.svg'
import boldIcon from '@/assets/tiptap/bold.svg'
import italicIcon from '@/assets/tiptap/italic.svg'
import strikeIcon from '@/assets/tiptap/strike.svg'
import quoteIcon from '@/assets/tiptap/quote.svg'
import bulletListIcon from '@/assets/tiptap/bullet_list.svg'
import orderedListIcon from '@/assets/tiptap/ordered_list.svg'
import linkIcon from '@/assets/tiptap/link.svg'
import removeLinkIcon from '@/assets/tiptap/remove_link.svg'
import fullscreenIcon from '@/assets/tiptap/fullscreen.svg'
import undoIcon from '@/assets/tiptap/undo.svg'
import redoIcon from '@/assets/tiptap/redo.svg'
import unsetMarksIcon from '@/assets/tiptap/unset_marks.svg'
import underlineIcon from '@/assets/tiptap/underline.svg'
import previewIcon from '@/assets/tiptap/preview.svg'
import imageIcon from '@/assets/tiptap/image.svg'
import videoIcon from '@/assets/tiptap/video.svg'
import tableIcon from '@/assets/tiptap/table.svg'
import errorIcon from '@/assets/ic_stop.svg'
import alignLeft from '@/assets/tiptap/align_left.svg'
import alignRight from '@/assets/tiptap/align_right.svg'
import alignJustify from '@/assets/tiptap/align_justify.svg'
import alignCenter from '@/assets/tiptap/align_center.svg'
import { mixin as clickaway } from 'vue-clickaway'
import { getBase64, getExtension } from '../../utils/file'
import { uploadFile } from '../../services/FileUploadService'
import { isError } from '../../utils/api'
import { getOEmbedUrl, getOEmbedHtml } from '../../utils/embed'

export default {
  mixins: [clickaway],
  props: [
    'editor',
    'showFullscreen',
    'showPreview',
    'heading',
    'bold',
    'italic',
    'strike',
    'underline',
    'removeMarks',
    'unorderedList',
    'orderedList',
    'quote',
    'link',
    'removeLink',
    'image',
    'video',
    'undo',
    'redo',
    'preview',
    'fullscreen',
    'table'
  ],
  data() {
    return {
      headingIcon,
      tableIcon,
      boldIcon,
      italicIcon,
      strikeIcon,
      quoteIcon,
      bulletListIcon,
      orderedListIcon,
      linkIcon,
      removeLinkIcon,
      fullscreenIcon,
      undoIcon,
      redoIcon,
      unsetMarksIcon,
      underlineIcon,
      previewIcon,
      imageIcon,
      videoIcon,
      errorIcon,
      alignLeft,
      alignRight,
      alignJustify,
      alignCenter,
      showImageOptions: false,
      showLinkInput: false,
      showVideoInput: false,
      showImageInput: false,
      uploadingImage: false,
      uploadImageError: false,
      invalidVideoUrl: false,
      imageSizeError: false,
      imageExtensionError: false,
      imageFile: null,
      imageUrl: '',
      linkUrl: '',
      videoUrl: ''
    }
  },
  watch: {
    showImageOptions() {
      if (!this.showImageOptions) {
        this.imageFile = null
        this.imageSizeError = false
        this.imageExtensionError = false
        this.uploadImageError = false
      } else {
        this.uploadImageError = false
      }
    },
    showVideoInput(value) {
      if (!value) {
        this.videoUrl = ''
        this.invalidVideoUrl = false
      }
    }
  },
  methods: {
    displayImageOptions() {
      this.showImageOptions = true
    },
    hideImageOptions() {
      this.showImageOptions = false
    },
    displayImageInput() {
      this.showImageOptions = false
      this.showImageInput = true
      this.$nextTick(() => {
        this.$refs.imageInput.focus()
      })
    },
    hideImageInput() {
      this.showImageInput = false
    },
    displayLinkInput() {
      const previousUrl = this.editor.getAttributes('link').href
      if (previousUrl) this.linkUrl = previousUrl
      this.showLinkInput = true
      this.$nextTick(() => {
        this.$refs.linkInput.focus()
      })
    },
    hideLinkInput() {
      this.showLinkInput = false
    },
    displayVideoInput() {
      this.showVideoInput = true
      this.$nextTick(() => {
        this.$refs.videoInput.focus()
      })
    },
    hideVideoInput() {
      this.showVideoInput = false
    },
    async uploadImage(evt) {
      this.uploadImageError = false
      this.imageSizeError = false
      this.imageExtensionError = false
      const file = evt.target.files[0]
      const extension = getExtension(file.name)
      const fileSizeMb = (file.size / (1024 * 1024).toFixed(2))
      if (!/png|jpg|jpeg/.test(extension)) this.imageExtensionError = true
      else if (fileSizeMb > 10) this.imageSizeError = true
      else {
        this.showImageOptions = false
        this.uploadingImage = true
        const base64 = await getBase64(file)
        const response = await uploadFile({ content: base64, extension }).catch(e => e.response)
        const success = !isError(response.status)
        if (success) {
          this.editor.chain().focus().setImage({ src: response.data }).run()
          this.imageFile = null
        } else this.uploadImageError = true
      }
      this.uploadingImage = false
    },
    submitImageUrl() {
      if (this.imageUrl) this.editor.chain().focus().setImage({ src: this.imageUrl }).run()
      this.showImageInput = false
      this.imageUrl = ''
    },
    submitLinkUrl() {
      const previousUrl = this.editor.getAttributes('link').href
      const url = this.linkUrl || previousUrl
      // cancelled
      if (url === null) {
        this.showLinkInput = false
        this.linkUrl = ''
        return
      }
      // empty
      if (url === '') {
        this.editor
          .chain()
          .focus()
          .extendMarkRange('link')
          .unsetLink()
          .run()
        this.showLinkInput = false
        this.linkUrl = ''
        return
      }
      // update link
      this.editor
        .chain()
        .focus()
        .extendMarkRange('link')
        .setLink({ href: this.linkUrl })
        .run()
      this.showLinkInput = false
      this.linkUrl = ''
    },
    async submitVideoUrl() {
      const oembedUrl = getOEmbedUrl(this.videoUrl)
      if (!this.videoUrl || !oembedUrl) return
      const html = await getOEmbedHtml(oembedUrl)
      if (html) {
        this.editor.commands.insertContent(html, {
          parseOptions: {
            preserveWhitespace: false
          }
        })
        this.showVideoInput = false
        this.videoUrl = ''
      } else {
        this.invalidVideoUrl = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/_colors.scss';

.menu-container{
  flex-wrap: wrap;
  &>*{
    margin-bottom: 5px;
  }
  &>:not(:last-child){
    margin-right: 4px;
  }
  button{
    width: 30px;
    height: 30px;
    font-size: 16px;
    padding-top: 2px;
    border-radius: 5px;
    border: 1px solid $gray;
    color: $dark-gray;
    img{
      width: 16px;
      filter: invert(100%) brightness(20%);
      &.small{
        width: 10px;
      }
      &.medium{
        width: 13px;
      }
      &.large{
        width: 18px;
      }
      &.xlarge{
        width: 22px;
      }
    }
    &.is-active{
      background-color: $red;
      border: 1px solid $red;
      color: $white;
      img{
        filter: invert(100%);
      }
    }
  }
}

.image-button{
  position: relative;
  .image-options{
    cursor: default;
    position: absolute;
    background-color: $light-gray;
    padding: 5px;
    width: 350px;
    top: 35px;
    z-index: 1;
    border-radius: 5px;
    .option{
      --max-width: auto;
      cursor: pointer;
      border: none;
    }
  }
}

.table-menu{
  width: 200px;
  background-color: $white;
  z-index: 2;

  .table-menu-item{
    padding: 6px 10px;
    cursor: pointer;
    &:hover{
      background-color: $light-gray;
    }
  }
}

@keyframes loading-bar {
  0% { background: linear-gradient(to right, $green 0%, $gray 0%); }
  25% { background: linear-gradient(to right, $green 50%, $gray 50%); }
  50% { background: linear-gradient(to right, $green 75%, $gray 75%); }
  100% { background: linear-gradient(to right, $green 90%, $gray 90%); }
}

.button-loading {
  background-color: $gray;
  min-width: 150px;
  background: linear-gradient(to right, $green 90%, $gray 90%);
  animation: loading-bar 5s;
  color: $white;
  height: 30px;
  border: none;
}

.file-input{
  display: none;
}
</style>
